const formfields = {
  Name: {
    index: 1,
    label: "Name:",
    placeholder: "Enter your name...",
    lines: 1,
    variable: "name",
    type: "text",
    fill: "input",
  },

  OrganisationName: {
    index: 2,
    label: "Organisation's Name:",
    placeholder: "Enter your organisation's name...",
    lines: 1,
  },

  Role: {
    index: 3,
    label: "Your role:",
    placeholder: "Describe your role in the organisation...",
    lines: 2,
  },

  WhatYouDo: {
    index: 4,
    label: "What do you do?",
    placeholder: "Tell us about what your organisation does",
    lines: 3,
  },

  Mission: {
    index: 5,
    label: "Mission and Vision",
    placeholder: "Tell us about your mission and your vision",
    lines: 5,
  },
  Goal: {
    index: 6,
    label: "5 Year Plan",
    placeholder:
      "Tell us about a goal you want to achieve in the next 5 years.",
    lines: 5,
  },

  Function: {
    index: 7,
    label: "Non-negotiables",
    placeholder: "What do you want users to be able to do on this website",
    lines: 7,
  },
  Inspo: {
    index: 8,
    label: "Website Inspiration",
    placeholder:
      "What websites are inspirations to you? (choose up to 10 websites and specify what features you enjoy)",
    lines: 10,
  },
  Email: {
    index: 9,
    label: "Email:",
    placeholder: "Enter your email address...",
    lines: 1,
  },
  Message: {
    index: 10,
    label: "Message:",
    placeholder:
      "Tell us a bit about your company and what you’re looking for...",
    lines: 5,
  },

  Reason: {
    index: 11,
    label: "What inspired you to reach out about a new website right now?",
    placeholder:
      "Tell us why you’re looking for a new website or redesign at this stage.",
    lines: 3,
  },

  ExistingSite: {
    index: 12,
    label: "Do you already have a website, or would this be your first one?",
    placeholder:
      "Share your current website link (if you have one) or let us know it’s a first build.",
    lines: 2,
  },

  Audience: {
    index: 13,
    label: "Who is your target audience or ideal visitor?",
    placeholder:
      "Describe the type of people or businesses you want to attract to your site.",
    lines: 3,
  },
  Organisation: {
    index: 14,
    label: "Can you tell me a little about your organisation and what you do?",
    placeholder:
      "Give us a brief overview of your organisation’s mission and services.",
    lines: 3,
  },

  Unique: {
    index: 15,
    label:
      "What makes your organisation unique compared to others in your space?",
    placeholder:
      "Highlight what sets you apart or why clients choose you over competitors.",
    lines: 3,
  },

  Branding: {
    index: 16,
    label:
      "Do you have any existing branding (logo, colours, fonts) we should use?",
    placeholder:
      "Tell us if you already have branding guidelines or visual assets to follow.",
    lines: 2,
  },

  Functionality: {
    index: 17,
    label: "What do you want visitors to be able to do on your website?",
    placeholder:
      "List the key actions (e.g. contact you, book services, shop, donate, register).",
    lines: 3,
  },

  Features: {
    index: 18,
    label: "Are there any specific features you need?",
    placeholder:
      "Mention features like e-commerce, event booking, membership, or a blog.",
    lines: 3,
  },

  Inspiration: {
    index: 19,
    label:
      "Do you have examples of websites you admire, and what do you like about them?",
    placeholder:
      "Share website links and explain which design or features you’d like to emulate.",
    lines: 4,
  },

  Success: {
    index: 20,
    label:
      "What does success look like for you after the new website launches?",
    placeholder:
      "Describe what a successful website would achieve for your organisation (e.g. more leads, sales, awareness).",
    lines: 3,
  },
  businessName: {
    label: "Business Name",
    placeholder: "Enter your business name",
  },
  businessTagline: {
    label: "Tagline (if any)",
    placeholder: "Your business tagline",
  },
  businessDescription: {
    label: "Business Description",
    placeholder: "Describe your business (50-100 words)",
    lines: 4,
  },
  productsServices: {
    label: "Products / Services",
    placeholder: "List your main products or services",
    lines: 3,
  },
  targetAudience: {
    label: "Target Audience",
    placeholder: "Who are your ideal customers?",
    lines: 2,
  },
  uniqueSellingPoints: {
    label: "What sets your business apart?",
    placeholder: "Explain your unique selling points (50-100 words)",
    lines: 3,
  },
  brandAssets: {
    label: "Brand Assets",
    placeholder:
      "Do you have logos, brand colors, or other marketing materials?",
    lines: 2,
  },

  websitePrimaryGoal: {
    label: "Primary Goal of Website",
    placeholder: "What is the main purpose of your website?",
  },
  visitorActions: {
    label: "Desired Visitor Actions",
    placeholder: "What actions should visitors take?",
  },
  businessGoals: {
    label: "Top 3 Business Goals",
    placeholder: "List your top 3 business goals (50-100 words)",
    lines: 3,
  },
  competitorInspiration: {
    label: "Competitors or Inspiration",
    placeholder: "Provide links to websites you admire and why",
    lines: 3,
  },
  preferredTone: {
    label: "Preferred Tone / Style",
    placeholder: "E.g. professional, playful, luxurious",
  },
  homepageSummary: {
    label: "Homepage Summary",
    placeholder: "Write a short summary about your business (100-150 words)",
    lines: 4,
  },
  aboutStory: {
    label: "About Page / Founder Story",
    placeholder: "Your business story (150-300 words)",
    lines: 6,
  },
  servicesDescription: {
    label: "Services / Products Description",
    placeholder: "Describe each main service or product (50-100 words each)",
    lines: 6,
  },
  testimonials: {
    label: "Testimonials / Case Studies",
    placeholder: "Provide any testimonials, reviews, or case studies",
    lines: 4,
  },
  brandImages: {
    label: "Brand Images",
    placeholder: "Do you have professional photography or brand images?",
  },
  blogSection: {
    label: "Blog / News Section",
    placeholder: "Do you need a blog? Provide existing posts if available",
    lines: 3,
  },

  desiredFeatures: {
    label: "Website Features",
    placeholder: "What features should your website include?",
  },
  ecommerceNeeds: {
    label: "E-commerce Needs",
    placeholder: "Will you sell products? How many?",
  },
  integrations: {
    label: "Integrations",
    placeholder: "Do you need integrations like email marketing or CRM?",
  },
  domainHosting: {
    label: "Domain / Hosting",
    placeholder: "Do you have domain and hosting, or need help?",
  },
  maintenancePlan: {
    label: "Maintenance / Updates",
    placeholder: "Who will update your site?",
  },

  analyticsTracking: {
    label: "Analytics / Tracking",
    placeholder: "Do you have Google Analytics, Search Console, etc.?",
  },
  seoKeywords: {
    label: "SEO / Keywords",
    placeholder: "Any existing SEO or keywords to target?",
  },
  additionalNotes: {
    label: "Additional Notes",
    placeholder: "Anything else we should know?",
    lines: 3,
  },
  TellUs: {
    label: "Your experience",
    placeholder: "Tell us about your experience working with us",
    lines: 5,
  },
  EBI: {
    label: "What would you change?",
    placeholder: "Tell us how your experience could've been better",
    lines: 2,
  },
  LandingPageMessage: {
    label: "Message",
    placeholder:
      "Tell us more about the project you need a landing page for...",
    lines: 5,
  },
};
export default formfields;
